// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"101e0c81","498":"9bc78dd2","513":"61fa1ce8","787":"545aecf5"}[chunkId] + ".chunk.js";
};